import React from "react";
import LegalLayout, { LegalBlock } from "@/components/legal/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      seoTitle="Privacy Policy | ETAP"
      description="How ETAP handles your information: read only bank data through Plaid, payment authorization through Stripe, and the controls you have over your data."
      path="/privacy"
      lastUpdated="To be confirmed by counsel"
      intro="This template describes how ETAP collects, uses, and protects information. Final language will be confirmed by counsel before launch."
    >
      <LegalBlock heading="Overview">
        <p>
          ETAP is a product of Flynaut LLC. This policy explains what information we collect, why we collect it, and the
          choices you have. It is written to be read, not to hide behind jargon.
        </p>
      </LegalBlock>
      <LegalBlock heading="Information we collect">
        <p>
          Account details you provide, such as name and email. Transaction data we read through Plaid on the accounts
          you choose, used only to detect income and calculate your set aside. We do not receive or store your bank
          login credentials.
        </p>
      </LegalBlock>
      <LegalBlock heading="How we use information">
        <p>
          To route the percentage you choose toward federal and state estimated taxes, to show your dashboard and
          reports, and to operate and secure the service. We do not sell your personal information.
        </p>
      </LegalBlock>
      <LegalBlock heading="Bank access and payments">
        <p>
          Bank access is read only through Plaid. Payment movement is authorized through Stripe. ETAP never holds your
          funds and is not a bank or custodian.
        </p>
      </LegalBlock>
      <LegalBlock heading="Data sharing">
        <p>
          We share information with service providers who help us operate, such as Plaid and Stripe, under agreements
          that limit their use of it. Placeholder for the full list of subprocessors, to be provided.
        </p>
      </LegalBlock>
      <LegalBlock heading="Your choices and rights">
        <p>
          You can pause routing, change your percentages, or withdraw consent at any time. You may request access to or
          deletion of your data as described here. Placeholder for jurisdiction specific rights, to be confirmed.
        </p>
      </LegalBlock>
      <LegalBlock heading="Data retention and security">
        <p>
          We keep information only as long as needed to provide the service and meet legal obligations. Placeholder for
          security measures and retention periods, to be confirmed.
        </p>
      </LegalBlock>
      <LegalBlock heading="Contact">
        <p>
          Questions about privacy can be sent to{" "}
          <a href="mailto:privacy@etaptax.com" className="font-semibold text-etap-primary underline underline-offset-2">
            privacy@etaptax.com
          </a>
          .
        </p>
      </LegalBlock>
    </LegalLayout>
  );
}
